/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

// MaterialUI
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

// assets
import CssSubscriptionSteps from './SubscriptionSteps.scss';

const SubscriptionSteps = props => {
  useStyles(CssSubscriptionSteps);
  const userIsRegistered = useSelector(state => state.user.logged_in);
  const userHasSubscribed = useSelector(state => state.user.subscription?.is_valid);
  const userRegisteredAt = useSelector(state => state.user.registered_at);

  let activeStep;
  if (userHasSubscribed) {
    activeStep = 2;
  } else if (userIsRegistered) {
    activeStep = 1;
  } else {
    activeStep = 0;
  }

  let { stepOne } = props;
  if (activeStep > 1) {
    const oneDayAgo = dayjs().subtract(1, 'day');
    if (userRegisteredAt && dayjs(userRegisteredAt).isBefore(oneDayAgo)) {
      stepOne = 'Sign in';
    }
  }
  const steps = [stepOne, 'Choose plan and pay'];

  return (
    <Stepper className="subscription-steps" activeStep={activeStep} alternativeLabel>
      {steps.map(label => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

SubscriptionSteps.propTypes = {
  stepOne: PropTypes.string,
};

SubscriptionSteps.defaultProps = {
  stepOne: 'Register',
};

export default React.memo(SubscriptionSteps);
